export class MasheryToken {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
    refreshTokenExpiresIn?: number;
    userContext: string;
    code: string;
    refreshToken: string;
    tokenDateTime: number;

    constructor(token = null) {
        if (token) {
            this.accessToken = token.access_token ? token.access_token : '';
            this.tokenType = token.token_type ? token.token_type : '';
            this.refreshToken = token.refresh_token ? token.refresh_token : '';
            this.expiresIn = token.expires_in ? token.expires_in : '';
        }
    }
}
